import * as React from 'react';
import Select from 'react-select';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { getAllAddresses, selectLocations, Location } from '../../redux/AddressSlice';
import utilityHelper from '../../utils/utilityHelper';

const AddressEditorWithValidation = (props: any) => {

    const dispatch = useAppDispatch();
    const locationSelector = useAppSelector(selectLocations);

    const cityLocationOptions = getFlattenedCityOptions();

    const [city, setCity] = React.useState<{ value: string; label: string; } | "" | undefined>();
    const [isCityCodeValid, setIsCityCodeValid] = React.useState<boolean>(false);

    function getFlattenedCityOptions(): Array<{ value: string; label: string; }> {
        let result: Array<{ value: string; label: string; }> = new Array<{ value: string; label: string; }>();

        locationSelector.forEach((stateNode: any) => {
            stateNode.children.forEach((countyNode: any) => {

                if (countyNode.level == "CITY") {
                    result.push({ value: countyNode.code, label: stateNode.name == 'Florida' ? countyNode.name : countyNode.name + " (" + stateNode.name + ")" });
                }

                countyNode.children.forEach((cityNode: any) => {
                    if (cityNode.level == "CITY") {
                        result.push({ value: cityNode.code, label: cityNode.name });
                    }
                })
            })
        })
        // todo: sort the list by label
        result.sort((a, b) => a.label > b.label ? 1 : -1);

        return result;
    }

    

    const shouldDisableZipEditing = function () {
        if (!props.canEdit) {
            return true;
        }
        if (props.hasOwnProperty("disableZipEditing")) {
            return true;
        }
        return false;
    }

    const handleCitySelectorChange = (selectItem: { value: string; label: string }) => {

        //attempt to retrieve the state county city hierarchy given the selected item value
        const stateCountyCityHierarchy = locationSelector.find((stateNode: Location) => stateNode.children
            .some((countyNode: Location) => countyNode.children
                .some((cityNode: Location) => cityNode.code == selectItem.value)));

        //if successful use hiearchy to set the state and county
        if (stateCountyCityHierarchy !== undefined) {
            props.setState(stateCountyCityHierarchy.name);

            const countyNode = stateCountyCityHierarchy.children.find((countyNode: Location) => countyNode.children
                .some((cityNode: Location) => cityNode.code == selectItem.value));

            if (countyNode !== undefined) {
                props.setCounty(countyNode.name);
            } else {
                props.setCounty("");
            }
        }
        //if unsuccessful retrieve state city hierarchy
        else {

            const stateCityHierarchy = locationSelector.find((stateNode: Location) => stateNode.children
                .some((cityNode: Location) => cityNode.code == selectItem.value));

            props.setCounty("");

            //if successful set state
            if (stateCityHierarchy !== undefined) {
                props.setState(stateCityHierarchy.name)
            }
            //if unsuccessful make it blank
            else {
                props.setState("");
            }

        }

        // Updating the state with the selected value
        setCity({ value: selectItem.value, label: selectItem.label });
        props.setCityCode(selectItem.value);
    }

    React.useEffect(() => {
        if (locationSelector === null ||
            (locationSelector !== null && locationSelector.length === 0)
        ) {
            dispatch(getAllAddresses());
        }
    }, []);

    React.useEffect(() => {
        if (props.cityCode) {
            var selectedOption = cityLocationOptions.find(element => element.value == props.cityCode);

            if (selectedOption) {
                handleCitySelectorChange({ value: selectedOption.value, label: selectedOption.label })
                setIsCityCodeValid(true);
            }
            else {
                props.setCityCode(null);
                setCity("");
                setIsCityCodeValid(false);
            }
        } else {
            props.setCityCode(null);
            setCity("");
            setIsCityCodeValid(false);
        }
    }, [props])


    return (
        <React.Fragment>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >Street:</Label>
                    </Col>
                    <Col md="9">
                        <Input type="text" value={props.street || ""}
                            valid={props.streetOrPOIsValid == true}
                            invalid={props.streetOrPOIsValid == false}
                            onChange={(e) => props.setStreet(e.currentTarget.value)}
                            disabled={!props.canEdit} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >P.O. Box:</Label>
                    </Col>
                    <Col md="9">
                        <Input type="text" value={props.poBox || ""}
                            valid={props.streetOrPOIsValid == true}
                            invalid={props.streetOrPOIsValid == false}
                            onChange={(e) => props.setPoBox(e.currentTarget.value)}
                            disabled={!props.canEdit} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >City:</Label>
                    </Col>
                    <Col md="9" style={{ borderColor: props.cityCode && props.cityCode != "fl_(selectacity)" && props.cityCode != "" ? '#dc3545' : '#28a745' }}>
                        <div hidden={ !(props.cityCode && props.cityCode != "fl_(selectacity)" && props.cityCode != "") }>
                            <Select
                                value={city}
                                onChange={handleCitySelectorChange}
                                options={cityLocationOptions}
                                style={{ width: "25em" }}
                                isDisabled={!props.canEdit}          
                                styles={{
                                    control: (baseStyles: any, state: any) => ({
                                        ...baseStyles,
                                        borderColor: '#28a745' ,
                                    }),
                                }}
                            />
                        </div>
                        
                        <div hidden={(props.cityCode && props.cityCode != "fl_(selectacity)" && props.cityCode != "")}>
                            <Select
                                value={city}
                                onChange={handleCitySelectorChange}
                                options={cityLocationOptions}
                                style={{ width: "25em" }}
                                isDisabled={!props.canEdit}
                                styles={{
                                    control: (baseStyles: any, state: any) => ({
                                        ...baseStyles,
                                        borderColor: '#dc3545',
                                    }),
                                }}
                            />
                        </div>

                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >County: </Label>
                    </Col>
                    <Col md="9">
                        <Input disabled type="text" value={props.county || ""} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >State: </Label>
                    </Col>
                    <Col md="9">
                        <Input disabled type="text" value={props.state || ""} />
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup>
                <Row>
                    <Col >
                        <Label >Zip Code:</Label>
                    </Col>
                    <Col md="9">
                        <Input type="text" value={props.zipCode || ""}
                            onChange={(e) => props.setZipCode(e.currentTarget.value)}
                            disabled={shouldDisableZipEditing()}
                            valid={utilityHelper.isTextPresent(props.zipCode) == true}
                            invalid={utilityHelper.isTextPresent(props.zipCode) == false}
                        />
                    </Col>
                </Row>
            </FormGroup>
        </React.Fragment>
    );
}

export default AddressEditorWithValidation;